import Vue from 'vue'
// eslint-disable-next-line no-unused-vars
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable'
// eslint-disable-next-line no-unused-vars
import CurrencyInput from '@/components/ui/currencyInput'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import moment from 'moment'

const cellRenderParamsConfig = Vue.extend({
  data() {
    return {
      active: false,
      breakfastTime: '08:30 -09:00',
      balanceCodeOptions: [
        {
          value: 'a',
          label: 'A'
        },
        {
          value: 'b',
          label: 'B'
        },
        {
          value: 'c',
          label: 'C'
        },
        {
          value: 'd',
          label: 'D'
        },
        {
          value: 'l',
          label: 'L'
        }
      ],
      whPoPricePrecisionOptions: [
        {
          value: 0,
          label: '0'
        },
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        }
      ],
      whPoTotalAmountPrecisionOptions: [
        {
          value: 0,
          label: '0'
        },
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        }
      ],
      value: ''
    }
  },
  beforeMount() {
    if (this.params) this.active = this.params.active
    this.value = this.params.value
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.changeInput(
        this.params.data.id,
        this.value
      )
    }
  },
  template: `
  <div style="width: 100%; text-align: center" class="config-params-modified">
    <input v-if="params.data.id == 1" type="checkbox" v-model="value" checked="value" @change="changeInput"/>
    <input type="text" v-if="params.data.id == 2" @blur="changeInput" v-model="value" />
    <select v-if="params.data.id == 3" @change="changeInput" v-model="value" style="width: 100%;">
      <option v-for="item in balanceCodeOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">{{item.label}}</option>
    </select>
    <input v-if="params.data.id == 4" type="checkbox" v-model="value" checked="value" @change="changeInput"/>
    <input type="text" v-if="params.data.id == 5" @blur="changeInput" v-model="value" />
    <input v-if="params.data.id == 6" type="checkbox" v-model="value" checked="value" @change="changeInput"/>
    <input v-if="params.data.id == 7" type="checkbox" v-model="value" checked="value" @change="changeInput"/>
    <select v-if="params.data.id == 8" @change="changeInput" v-model="value">
      <option v-for="item in whPoPricePrecisionOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">{{item.label}}</option>
    </select>
    <select v-if="params.data.id == 9" @change="changeInput" v-model="value">
      <option v-for="item in whPoTotalAmountPrecisionOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">{{item.label}}</option>
    </select>
    <input v-if="params.data.id == 10" type="checkbox" v-model="value" checked="value" @change="changeInput"/>
  </div>
  `
})

const CellRenderToggleSwitchReadOnly = Vue.extend({
  data() {
    return {
      active: false
    }
  },
  beforeMount() {
    if (this.params) this.active = this.params.active
  },
  methods: {},
  template: `
  <el-switch
    v-model="active"
    active-color="#399f6e"
    inactive-color="#CAC9C9"
    disabled
    style="opacity: 1 !important"
  >
  </el-switch>
  `
})
const CellRenderToggleSwitch = Vue.extend({
  data() {
    return {
      active: false
    }
  },
  beforeMount() {
    if (this.params) this.active = this.params.active
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.togglePackageCategory(this.params)
    }
  },
  template: `
  <label class="switch">
    <input type="checkbox" :checked="active" :value="active" @change="changeInput">
    <span class="slider round"></span>
  </label>
  `
})

const CellRenderColorPicker = Vue.extend({
  data() {
    return {
      color: ''
    }
  },
  beforeMount() {
    if (this.params) this.color = this.params.color
  },
  methods: {
    onClick() {
      return false
    }
  },
  template: `
  <div style="display: flex; justify-content: start;">
    <div style="width: 30px; height: 30px; border-radius: 5px" :style="{ 'background-color': color }"></div>
  </div>
  `
})

const CellRenderCheckbox = Vue.extend({
  data() {
    return {
      value: false,
      colName: null,
      id: 'slcrd' + Math.floor(Math.random() * 100000),
      disabled: null
      // hotel_id: null
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
    this.params.colName ? (this.colName = this.params.colName) : null
    this.params.disabled ? (this.disabled = this.params.disabled) : false

    // this.params.hote ? (this.disabled = this.params.disabled) : false
    this.params.hotel_id ? (this.hotel_id = this.params.hotel_id) : null
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.changeCheckbox(
        this.colName,
        this.params,
        this.value
      )
    }
    // :disabled="!params.data.custom_price && colName !== 'custom_price'"
  },
  template: `
  <div class="checkbox-wrap"
  style="width: 100%; height: 100%; display: flex; justify-content: flex-start; align-items: center;"
>
  <input
    :id="id"
    :disabled="disabled || (colName=='isBf' && hotel_id !== 45)"
    v-model="value"
    :checked="value"
    type="checkbox"
    @change="changeInput"
  />
  <label :for="id" />
</div>
  `
})

const CellRenderCheckboxReadonly = Vue.extend({
  data() {
    return {
      value: false
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
  },
  methods: {
    onClick(e) {
      e.stopPropagation()

      return false
    }
  },
  template: `
    <div class="cell-renderer-checkbox__readonly" :class="{ 'checked': value }"></div>
  `
})

const CellRenderEditIcon = Vue.extend({
  data() {
    return {
      value: false
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
  },
  methods: {
    onIconClicked() {
      this.params.context.componentParent.onIconClicked(this.params)
    }
  },
  template: `
  <div style="display: flex; justify-content: center;">
    <i style="cursor: pointer;" class="el-icon-edit" @click="onIconClicked"></i>
  </div>
  `
})

const CellRenderOpenDialogWhenCLicked = Vue.extend({
  data() {
    return {
      // value: null
    }
  },
  beforeMount() {
    // if (this.params) this.value = this.params.value
  },
  methods: {
    onClick() {
      // 1.GridName
      // 2.ColNm
      // 3.RowIdx
      this.params.context.componentParent.opendialogByCellRenderComp(
        this.params.refName,
        this.params.column.colId,
        this.params.rowIndex
      )
    }
  },
  template: `
    <span style="font-weight: 700; cursor: pointer; color: #357456" @click="onClick">{{this.params.value ?? null}}</span>
  `
})

const CellRenderDeleteIcon = Vue.extend({
  data() {
    return {
      value: false
    }
  },
  beforeMount() {
    if (this.params) this.value = this.params.value
  },
  methods: {
    onIconClicked() {
      this.params.context.componentParent.onDeleteIconClicked(this.params)
    }
  },
  template: `
  <div style="display: flex; justify-content: center; align-items: center; gap: 5px; cursor: pointer;">
    <i style="cursor: pointer;" class="el-icon-delete-solid" @click="onIconClicked"></i>
  </div>
  `
})

const CellRenderSelect = Vue.extend({
  data() {
    return {
      value: '',
      // type: 'text',
      refName: null,
      disabled: null,
      options: []
    }
  },
  watch: {
    // value() {
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     this.value
    //   )
    // }
  },
  beforeMount() {
    if (this.params?.value) {
      this.value = this.params.value
    }
    this.params.refName ? (this.refName = this.params.refName) : null
    // this.params.type ? this.type = this.params.type : null
    this.params.options ? (this.options = this.params.options) : null
    this.params.disabled ? (this.disabled = this.params.disabled) : false
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.SelectInputChange(
        this.refName,
        this.params,
        this.value
      )
    }
    // :disabled="!params.data.custom_price && refName !== 'num_of_room' && refName !== 'num_of_guest'"
    //     <select :disabled="disabled" style="width: 100%" class="input-text-border-none" v-model="value" @change="changeInput">
    // <option v-for="item in options" :value="item.value" :key="item.value">{{ item.label }}</option>
    // </select>
  },
  template: `
    <el-select
    :disabled="disabled"
    v-model="value"
    placeholder=""
    size="small"
    @change="changeInput"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
  `
})

const CellRenderTextInput = Vue.extend({
  data() {
    return {
      value: '',
      type: 'text',
      disabled: null,
      colName: null
    }
  },
  watch: {
    // value() {
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     this.value
    //   )
    // }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.type ? (this.type = this.params.type) : null
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
    this.params.disabled ? (this.disabled = this.params.disabled) : false
  },
  methods: {
    changeInput() {
      if (this.type === 'number') {
        this.params.context.componentParent.textInputChange(
          this.params,
          +this.value,
          this.colName
        )
      } else {
        this.params.context.componentParent.textInputChange(
          this.params,
          this.value,
          this.colName
        )
      }
    }
    //   template: `<input :disabled="!params.data.custom_price && colName !== 'num_of_room' && colName !== 'num_of_guest'" class="input-text-border-none" min='0' :type="type" v-model="value" @blur="changeInput"/>`
  },
  template: `<input :disabled="disabled" class="input-text-border-none" min='0' :type="type" v-model="value" @blur="changeInput"/>`
})

const CellRenderNumInput = Vue.extend({
  /* eslint-disable */
  data() {
    return {
      value: '',
      type: 'text',
      colName: null,
      disabled: null,
      max: 1
    }
  },
  // watch: {
  //   value: {
  //     immediate: true,
  //     handler(newVal, oldVal) {
  //       if (newVal != oldVal) {
  //         this.value = newVal
  //       }
  //     }
  //   }
  // },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    // console.log('Value:', this.params.value)
    this.params.type ? (this.type = this.params.type) : null
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
    this.params.disabled ? (this.disabled = this.params.disabled) : false
  },
  methods: {
    changeInput() {
      if (this.type === 'number') {
        this.params.context.componentParent.textInputChange(
          this.params,
          +this.value,
          this.colName
        )
      } else {
        this.params.context.componentParent.textInputChange(
          this.params,
          this.value,
          this.colName
        )
      }
    },
    scrollValue(event) {
      event.preventDefault()
    }
  },
  template: `<input :disabled="disabled" class="input-text-border-none" v-numeric-only :type="type" @wheel="scrollValue" v-model="value" @blur="changeInput"/>`
})

const CellRenderInputSuggestion = Vue.extend({
  data() {
    return {
      value: ''
      // suggestions: [
      //   {
      //     value: 'porsche',
      //     link: 'porsche'
      //   },
      //   {
      //     value: 'mercedes',
      //     link: 'mercedes'
      //   },
      //   {
      //     value: 'toyota',
      //     link: 'toyota'
      //   }
      // ]
    }
  },
  watch: {
    // value() {
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     this.value
    //   )
    // }
  },
  beforeMount() {
    // if (this.params?.value) {
    //   this.value = this.params.value
    // }
  },
  mounted() {
    if (this.params.code) {
      this.value = this.params.code
    }
    this.links = this.loadAll()
  },
  methods: {
    querySearch(queryString, cb) {
      var links = this.links
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter(queryString) {
      return link => {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    loadAll() {
      return this.params.productSuggestionList
    },
    changeInput(data) {
      // setTimeout(() => {
      //   this.value = this.params.context.componentParent.code
      // }, 50)
      this.params.context.componentParent.suggestionInputChanged(
        this.params.rowIndex,
        data
      )
    }
  },
  template: `
  <div>
    <el-autocomplete
      class="inline-input"
      v-model="value"
      :fetch-suggestions="querySearch"
      @select="changeInput"
    >
    </el-autocomplete>
  </div>`
  // template: `<input class="input-text-border-none" type="text" v-model="value" @blur="changeInput"/>`
})

const CellRenderFullWidth = Vue.extend({
  data() {
    return {
      value: ''
    }
  },
  watch: {
    value() {
      this.params.context.componentParent.textInputChange(
        this.params,
        this.value
      )
    }
  },
  beforeMount() {
    if (this.params?.value) {
      this.value = this.params.value
    }
  },
  methods: {
    onSuggestions() {
      return [
        {
          value: 'porsche',
          link: 'https://github.com/vuejs/vue'
        },
        {
          value: 'mercedes',
          link: 'https://github.com/vuejs/vue'
        },
        {
          value: 'toyota',
          link: 'https://github.com/vuejs/vue'
        }
      ]
    }
    // changeInput() {
    //   // this.params.context.componentParent.someFunctionHere()
    // },
  },
  template: `<div>Cell Render Full Width</div>`
})

const CellRenderSelectWithSearchTable = Vue.extend({
  components: {
    SelectWithSearchTable
  },
  data() {
    return {
      indexField: '',
      searchFields: [],
      rows: [],
      columns: [],
      selectedIndexFieldValue: null,
      dropdownWidth: null,
      colName: null
    }
  },
  mounted() {
    this.indexField = this.params.indexField
    this.searchFields = this.params.searchFields
    this.rows = this.params.rows || []
    this.columns = this.params.columns || []
    this.selectedIndexFieldValue = this.params.selectedIndexFieldValue
    this.dropdownWidth = this.params.dropdownWidth
    this.colName = this.params.colName
  },
  methods: {
    onSelectRow(row) {
      this.params.context.componentParent.selectSearchTableChange(
        this.params,
        row,
        this.colName
      )
    }
  },
  render(h) {
    return h('div', [
      h(SelectWithSearchTable, {
        props: {
          size: 'mini',
          dropdownWidth: this.dropdownWidth,
          indexField: this.indexField,
          selectedIndexFieldValue: this.selectedIndexFieldValue,
          rows: this.rows,
          columns: this.columns,
          searchFields: this.searchFields
        },
        on: {
          selectionChanged: this.onSelectRow
        },
        scopedSlots: {
          value: ({ selectedValue: selectedData }) => {
            return h('span', [
              selectedData?.sub_transaction_id,
              ' ',
              selectedData?.sub_transaction_desc
            ])
          }
        }
      })
    ])
  }
  //  template:
  //   `
  //   <div>
  //     <SelectWithSearchTable
  //       size="mini"
  //       :dropdown-width="dropdownWidth"
  //       :index-field="indexField"
  //       :selectedIndexFieldValue="selectedIndexFieldValue"
  //       :rows="rows"
  //       :columns="columns"
  //       :search-fields="searchFields"
  //       @selectionChanged="onSelectRow"
  //     />
  //       <template v-slot:value="{ selectedValue: selectedData }">
  //         {{ selectedData?.sub_transaction_id }} {{ selectedData?.sub_transaction_desc }}
  //       </template>
  //     </SelectWithSearchTable>
  //   </div>
  //   `
})

const CellRenderCurrencyInput = Vue.extend({
  components: {
    CurrencyInput
  },
  data() {
    return {
      value: null,
      disabled: null,
      colName: null
    }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
    this.params.disabled ? (this.disabled = this.params.disabled) : false
  },
  methods: {
    changeInput() {
      this.params.context.componentParent.changeCurrencyInput(
        this.params,
        this.value,
        this.colName
      )
    }
    // onInput(val) {
    //   this.value = val
    // }
  },
  template: `
    <VxCurrencyInput :disabled="disabled"  class="input-text-border-none" v-model="value" @blur="changeInput" />
  `
})

const CellRenderCalendar = Vue.extend({
  components: {
    SingleCalendar
  },
  data() {
    return {
      value: null,
      colName: null
    }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeCalendar() {
      this.params.context.componentParent.changeCalendar(
        this.params,
        this.value,
        this.colName
      )
    }
    // onInput(val) {
    //   this.value = val
    // }
  },
  template: `
    <SingleCalendar
      v-model="value"
      class="use-icon"
      :date-data="value"
      @input="changeCalendar" />
  `
})

const CellRenderCalendarSelect = Vue.extend({
  components: {
    CalendarSelect
  },
  data() {
    return {
      value: null,
      colName: null,
      date: { min: null, max: null }
    }
  },
  watch: {
    // value() {
    //   // console.log('dc r')
    //   this.changeCalendar()
    // }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    changeCalendar() {
      this.params.context.componentParent.changeCalendar(
        this.params,
        this.value,
        this.colName
      )
    }
    // onInput(val) {
    //   this.value = val
    // }
  },
  template: `
    <CalendarSelect
      v-model="value"
      style="display: block; width: 100%"
      mode="date"
      :min-max="date"
      @input="changeCalendar"
    />
    `
})

const CellRenderCalendarSelectForTable = Vue.extend({
  components: {
    CalendarSelect
  },
  data() {
    return {
      value: null,
      colName: null,
      date: { min: '2024-01-05', max: '2024-01-10' },
      pickerOptions: null,
      clearable: false,
      dateType: 'date',
      format: 'dd/MM/yyyy',
      valueFormat: 'yyyy-MM-dd'
    }
  },
  watch: {
    // value() {
    //   // console.log('dc r')
    //   this.changeCalendar()
    // }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = moment(this.params.value).toDate()
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
    if (this.params.date !== null && this.params.date !== undefined) {
      this.date.min = moment(this.params.date.min).toDate()
      this.date.max = moment(this.params.date.max).toDate()
    } else {
      this.date = null
    }
    if (
      this.params.clearable !== null &&
      this.params?.clearable !== undefined
    ) {
      this.clearable = this.params.clearable
    }
    if (this.params.dateType !== null && this.params?.dateType !== undefined) {
      this.dateType = this.params.dateType
    }
    if (this.params.format !== null && this.params?.format !== undefined) {
      this.format = this.params.format
    }
    if (
      this.params.valueFormat !== null &&
      this.params?.valueFormat !== undefined
    ) {
      this.valueFormat = this.params.valueFormat
    }
    this.pickerOptions = { disabledDate: this.limitTime }
  },
  methods: {
    changeCalendar() {
      this.params.context.componentParent.changeCalendar(
        this.params,
        this.value,
        this.colName
      )
    },
    limitTime(time) {
      // console.log('hahaha', this.date)
      if (this.date !== null) {
        return time.getTime() < this.date.min || time.getTime() > this.date.max
      }
    }
    // onInput(val) {
    //   this.value = val
    // }
  },
  template: `
    <el-date-picker
      v-model="value"
      :type="dateType"
      placeholder=""
      :format='format'
      :value-format='valueFormat'
      size='large'
      :clearable="clearable"
      :picker-options="pickerOptions"
      @change="changeCalendar"
      popper-class="ag-cell-component__calendar-select"
    />
    `
})

export {
  CellRenderTextInput,
  CellRenderCheckbox,
  CellRenderEditIcon,
  CellRenderToggleSwitch,
  CellRenderFullWidth,
  cellRenderParamsConfig,
  CellRenderCheckboxReadonly,
  CellRenderToggleSwitchReadOnly,
  CellRenderColorPicker,
  CellRenderSelectWithSearchTable,
  CellRenderInputSuggestion,
  CellRenderDeleteIcon,
  CellRenderSelect,
  CellRenderCurrencyInput,
  CellRenderCalendar,
  CellRenderOpenDialogWhenCLicked,
  CellRenderNumInput,
  CellRenderCalendarSelect,
  CellRenderCalendarSelectForTable
  // End MCI
}
